import { useMessage } from '@tmapy/intl';

import '../../app/components/Badge.scss';

import {
  SvgSpinner,
  DangerBadge,
  Icon,
  InfoBadge,
  SuccessBadge,
  Badge,
} from '@tmapy/style-guide';

import { CHECK_STATE } from '../constants';
import { checkStateMessages } from './checkMessages';

type CheckBadgeProps = {
  state?: CHECK_STATE | null | undefined;
};

export const CheckBadge: React.FC<CheckBadgeProps> = ({ state }) => {
  const formatMessage = useMessage();
  const stateText = formatMessage(checkStateMessages[state ?? 'undefined']);

  switch (state) {
    case CHECK_STATE.WAITING_FOR_CHECKING:
    case CHECK_STATE.CHECKING: {
      return (
        <Badge unsafeClassName='dmx-badge--in-progress'>
          <div className='sg-a-d-f sg-a-ai-c'>
            <Icon element={<SvgSpinner />} />
            <span className='sg-a-ml-1/2 sg-a-ws-nw'>{stateText}</span>
          </div>
        </Badge>
      );
    }
    case CHECK_STATE.ABORTED: {
      return <DangerBadge>{stateText}</DangerBadge>;
    }
    case CHECK_STATE.FAILED: {
      return <DangerBadge isStrong>{stateText}</DangerBadge>;
    }
    case CHECK_STATE.PASSED: {
      return <SuccessBadge isStrong>{stateText}</SuccessBadge>;
    }
    default: {
      return <InfoBadge>{stateText}</InfoBadge>;
    }
  }
};
